import { Box, Button, CircularProgress, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { blueGrey } from '@material-ui/core/colors';
import { useDispatch } from 'react-redux';
import { handshakeRappi } from '../../../state/order/actions';

dayjs.extend(utc);

export const GerarTokenRappi = ({ dateDeExpiracao, tentativasDeValidacao, tokenJaGerado, codigoExterno }) => {
  const [dataExpiracao, setDataExpiracao] = useState(dateDeExpiracao);
  const [tokenGerado, setTokenGerado] = useState(tokenJaGerado);
  const [tentativasValidacao, setTentativasValidacao] = useState(tentativasDeValidacao || 0);
  const [tempoRestanteEmSegundos, setTempoRestanteEmSegundos] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const dispatch = useDispatch();

  const gerarTokenSubmit = async () => {
    setIsLoading(true);
    setErro(null);
    const res = await dispatch(handshakeRappi(codigoExterno));

    if (res && res.status === 200) {
      setDataExpiracao(res.data.dataExpiracao);
      setTokenGerado(true);
    } else if (res && res.status === 409) {
      setErro(res.data.message || 'Ocorreu um erro ao gerar o token. Tente novamente.');
    } else {
      setErro('Ocorreu um erro ao gerar o token. Tente novamente.');
    }

    setIsLoading(false);
  }

  useEffect(() => {
    if (!tokenGerado || !dataExpiracao) {
      setTempoRestanteEmSegundos(0);
      return;
    }

    const tempoLimite = dayjs(dataExpiracao).valueOf();

    const atualizarTempo = () => {
      const restante = Math.max(0, Math.ceil((tempoLimite - dayjs()) / 1000));
      setTempoRestanteEmSegundos(restante);
    };

    atualizarTempo();
    const interval = setInterval(atualizarTempo, 1000);
    return () => clearInterval(interval);
  }, [dataExpiracao, tokenGerado]);

  const minutosRestantes = Math.floor(tempoRestanteEmSegundos / 60);
  const segundosRestantes = tempoRestanteEmSegundos % 60;
  const podeGerarToken = !tokenGerado || tempoRestanteEmSegundos === 0 || tentativasValidacao >= 3;

  return (
    <Box display="flex" flexDirection="column" gridGap={24} alignItems="center" flexGrow={1}>
      <Box flexGrow={1}>
        <Typography variant='subtitle1'>
          Gere o código de retirada <strong>somente</strong> com o entregador na loja.
        </Typography>
        <Typography variant='body2'>
          O código gerado será enviado para o entregador, que deverá informar a loja para confirmação.
        </Typography>
      </Box>
      <Button
        variant="contained"
        color='primary'
        onClick={gerarTokenSubmit}
        disabled={!podeGerarToken || isLoading}
        style={{ backgroundColor: podeGerarToken && !isLoading ? blueGrey[800] : undefined }}
      >
        {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Gerar código'}
      </Button>
      {erro && <Box flexGrow={1}>
        <Typography variant='body2' color='primary'>
          {erro}
        </Typography>
      </Box>}
      {!podeGerarToken && <Box display="flex" gridGap={8} alignItems="center">
        <CircularProgress size={16} color="primary" />
        <Typography variant='body2'>
          Aguarde {minutosRestantes}:{segundosRestantes.toString().padStart(2, '0')} para gerar novamente
        </Typography>
      </Box>}
    </Box>
  )
}
